import type { ColumnsType } from 'antd/es/table';
import { TFunction } from 'i18next';
import withLoadingSkeleton from '@/HOCs/withLoadingSkeleton';
import { VoteResultType } from '../types';

export const voteResultsColumns = ({
  isLoading,
  t,
  isByOwnership = false,
}: {
  isLoading: boolean;
  t: TFunction<'plans'>;
  isByOwnership?: boolean;
}): ColumnsType<VoteResultType> => {
  const resultColumn = (title: string, resultIndex: number) => ({
    title,
    children: [
      {
        title: isByOwnership ? t('totalShares') : t('voteCount'),
        render: withLoadingSkeleton(isLoading, (_: unknown, record?: VoteResultType) =>
          (record?.results?.[resultIndex]?.count ?? 0).toLocaleString(),
        ),
        align: 'center' as const,
      },
      {
        title: isByOwnership ? t('ownership') : t('percentage'),
        render: withLoadingSkeleton(
          isLoading,
          (_: unknown, record?: VoteResultType) =>
            `${Number(record?.results?.[resultIndex]?.percentage ?? 0).toFixed(4)}%`,
        ),
        align: 'center' as const,
      },
    ],
  });

  return [
    {
      title: t('clause'),
      dataIndex: 'clause',
      sorter: true,
      render: withLoadingSkeleton(isLoading, (val: string) => val),
    },
    {
      title: t('question'),
      dataIndex: 'points_description',
      sorter: true,
      width: '40%',
      render: withLoadingSkeleton(isLoading, (val: string) => val),
    },
    resultColumn(t('yes'), 0),
    resultColumn(t('no'), 1),
    resultColumn(t('noVote'), 2),
    resultColumn(t('excluded'), 3),
  ];
};
